import { Card, Skeleton, Space } from "antd";
import IssueTableSkeleton from "./IssueTableSkeleton";

const UserCardSkeleton = () => (
  <Card className="user-issue-card user-issue-card--skeleton">
    <Skeleton
      active
      title={false}
      paragraph={false}
      avatar={{ shape: "circle", size: "small" }}
    />
    <Space style={{ marginBottom: 16 }}>
      <Skeleton.Input active size="small" style={{ width: 140 }} />
      <Skeleton.Input active size="small" style={{ width: 80 }} />
    </Space>
    <IssueTableSkeleton rows={3} />
  </Card>
);

export default UserCardSkeleton;
